/** Extract workspaceId from pathname or canonical query param (?ws=). */
export function extractWorkspaceId(pathname: string, search = ""): string | null {
  const match = pathname.match(/\/workspaces\/([^/]+)/);
  if (match?.[1]) return match[1];

  const params = new URLSearchParams(search);
  const qsWorkspace = params.get("ws");
  return qsWorkspace && qsWorkspace.trim().length > 0 ? qsWorkspace.trim() : null;
}
